import { configureStore } from "@reduxjs/toolkit";
import listingsReducer from './features/listingsSlice'

export const store = configureStore({
  reducer: {
    listings: listingsReducer,
  },
});